import { CustomerModelType } from '@teinor/erp/types/company/customer'
import ModalCECustomerShop from './ModalCECustomerWorkingCenter'
import { CustomerShopModelType } from '@teinor/erp/types/company/customer/customerShop'
import { ComponentWithPermissions } from '../../../../baseComponents/CreateRoutering/types'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import BaseScreenTableInner from '../../../../baseComponents/TwinTable/BaseScreenTableInner'
import { TableComponentBaseScreenInnerProps } from '../../../../baseComponents/TwinTable/BaseScreenTableInner/types'
import { ColumnTableSchema } from '../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { CustomRenderBoolean, DeleteRow, EditRow } from '../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { permissionCheck } from '../../../../baseComponents/PermissionChecker/function'
import TwinTable from '../../../../baseComponents/TwinTable'
import { faRotateLeft } from '@fortawesome/pro-light-svg-icons'
import ModalChangeActiveCustomerWC from './ModalChangeActiveCustomerWC'


interface CustomerWorkingCentersProps extends ComponentWithPermissions {
    basicData: CustomerModelType | null
}

const CustomerWorkingCenters: React.FC<CustomerWorkingCentersProps> = ({ basicData, userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('workingCenters', 'Centros de trabajo'),
        newText: t('newWorkingCenter', 'Nuevo centro de trabajo'),
    }

    return (
        <BaseScreenTableInner TableComponent={TableCustomerWorkingCenters} CreateModalComponent={ModalCECustomerShop} EditModalComponent={ModalCECustomerShop} DeleteModalComponent={ModalChangeActiveCustomerWC} pageData={pageData} userPermissions={userPermissions} extraWhereParams={{ CustomerId: basicData?.id }} />
    )
}
interface TableCustomerWorkingCentersProps extends TableComponentBaseScreenInnerProps { }

const TableCustomerWorkingCenters: React.FC<TableCustomerWorkingCentersProps> = ({ setOpened, setTableInstance, userPermissions, extraWhereParams }) => {
    const { t } = useTwinTranslation()

    const columns: ColumnTableSchema<CustomerShopModelType> = [
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
            minWidth: 130,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'address',
            dataKey: 'address',
            label: t('address', 'Dirección'),
            sortable: true,
            minWidth: 110,
        },
        {
            id: 'city',
            dataKey: 'city',
            label: t('city', 'Ciudad'),
            sortable: true,
        },
        {
            id: 'phone',
            dataKey: 'phone',
            label: t('phone', 'Teléfono'),
        },
        {
            id: 'email',
            dataKey: 'email',
            label: t('email', 'Email'),
        },
        {
            id: 'isMain',
            dataKey: 'isMain',
            label: t('isMainWC', 'Centro principal'),
            width: 150,
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={75} />
        },
        {
            id: 'active',
            dataKey: 'active',
            label: t('active', 'Activo'),
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={45} />,
            hideColumnByDefault: true,
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSingle',
                extraComponentData: {
                    items: {
                        'true': { name: t('actived', 'Activados') },
                        'false': { name: t('disableds', 'Desactivados') },
                        'all': { name: t('all', 'Todos') }
                    }, label: t('active', 'Activo')
                }
            },
            generalSearchable: false
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} icon={!allRowData?.active ? faRotateLeft : undefined} messageTooltip={!allRowData?.active ? t('reactivate', 'Reactivar') : t('deactivate', 'Desactivar')} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTable columns={columns} name='customerWorkingCenters' getDataFrom='/api/app/customer/customerShop/getAllCustomerShops'
            onRowClick={(_id, rowData) => setOpened({
                type: 'edit',
                allRowData: rowData,
            })} setTableInstance={setTableInstance} extraWhereParams={extraWhereParams} defaultOrder={{ defaultOrderField: 'isMain', order: 'desc' }}
        />
    )
}

export default CustomerWorkingCenters